import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import { deviceTypes } from '@styles/mediaQueries';
import { ReactComponent as AvatarPlaceholder } from '@assets/svg/avatar-placeholder.svg';
import { BrokenImageEnhanced } from '@components/BrokenImage/BrokenImageEnhanced';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;
export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
`;
interface IIcon {
  width: number;
}
export const Block = styled.div<IIcon>`
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: fixed;
  bottom: 16px;
  left: ${({ width }) => width - 4}px;
  min-width: 328px;
  z-index: 10;
  cursor: auto;
`;
export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;

export const Icon = styled.div<IIcon>`
  --sidebar-width: ${({ width }) => width}px;
  min-width: var(--sidebar-width);
  width: var(--sidebar-width);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ProfileImg = styled(BrokenImageEnhanced)`
  --size: 32px;
  width: var(--size);
  height: var(--size);
  border-radius: 16px;
  object-fit: cover;

  [data-device='${deviceTypes.mobile}'] & {
    --size: 16px;
  }
`;

export const StyledAvatarPlaceholder = styled(AvatarPlaceholder)`
  --size: 32px;
  width: var(--size);
  height: var(--size);
  [data-device='${deviceTypes.mobile}'] & {
    --size: 16px;
  }
`;
